module.exports = __webpack_public_path__ + "static/media/amy-300x300.928e5670.jpg";